'use strict';
import EventInitializer from './helper/EventInitializer';
import EventBinder from './helper/EventBinder';
var ExternalTracker = /** @class */ (function () {
    function ExternalTracker(tracker, config) {
        this.tracker = tracker;
        this.binder = new EventBinder(this.tracker);
        this.config = config;
        this.bindSearchBox();
        this.bindSuggestBox();
        this.bindSerp();
        this.bindAddToCart();
        this.bindCheckout();
    }
    ExternalTracker.prototype.bindSearchBox = function () {
        var _this = this;
        var searchBoxConfig = this.config.searchBox;
        if (!searchBoxConfig) {
            return;
        }
        var suggestBoxConfig = this.config.searchSuggestions;
        EventInitializer.bind(searchBoxConfig.initializationStrategy, function () {
            var suggestBlockSelector = suggestBoxConfig ? suggestBoxConfig.blockSelector : undefined;
            var suggestItemSelector = suggestBoxConfig ? suggestBoxConfig.itemSelector : undefined;
            var suggestActiveItemSelector = suggestBoxConfig ? suggestBoxConfig.activeItemSelector : undefined;
            var articleNumberSource = suggestBoxConfig ? suggestBoxConfig.articleNumberSource : undefined;
            var identifierSource = suggestBoxConfig ? suggestBoxConfig.identifierSource : undefined;
            _this.binder.bindSearchBoxEvents(searchBoxConfig.selector, searchBoxConfig.button, suggestBlockSelector, suggestItemSelector, suggestActiveItemSelector, articleNumberSource, identifierSource, searchBoxConfig.trackSubmitOnly, searchBoxConfig.ignoreForms);
        });
    };
    ExternalTracker.prototype.bindSuggestBox = function () {
        var _this = this;
        var suggestBoxConfig = this.config.searchSuggestions;
        if (!suggestBoxConfig) {
            return;
        }
        EventInitializer.bind(suggestBoxConfig.initializationStrategy, function () {
            _this.binder.bindSuggestBoxEvents(suggestBoxConfig.blockSelector, suggestBoxConfig.itemSelector, (_this.config.searchBox || {}).selector, suggestBoxConfig.articleNumberSource, suggestBoxConfig.identifierSource);
        });
    };
    ExternalTracker.prototype.bindSerp = function () {
        var _this = this;
        var serpConfig = this.config.searchResults;
        if (!serpConfig) {
            return;
        }
        EventInitializer.bind(serpConfig.initializationStrategy, function () {
            _this.binder.bindSerpEvents(serpConfig.expectedConditions, serpConfig.querySource, serpConfig.blockSelector, serpConfig.itemSelector, serpConfig.excludeActiveSelector, serpConfig.singleGroupSelector, serpConfig.articleNumberSource, serpConfig.identifierSource, serpConfig.rebindStrategy);
        });
    };
    ExternalTracker.prototype.bindAddToCart = function () {
        var _this = this;
        var cartConfig = this.config.productDetailPage;
        if (!cartConfig) {
            return;
        }
        EventInitializer.bind(cartConfig.initializationStrategy, function () {
            _this.binder.bindCartEvents(cartConfig);
        });
    };
    ExternalTracker.prototype.bindCheckout = function () {
        var _this = this;
        var checkoutConfig = this.config.checkout;
        if (!checkoutConfig) {
            return;
        }
        EventInitializer.bind(checkoutConfig.initializationStrategy, function () {
            _this.binder.bindCheckoutEvents(checkoutConfig);
        });
    };
    ExternalTracker.prototype.unbindAll = function () {
        this.binder.unbindAll();
    };
    return ExternalTracker;
}());
export default ExternalTracker;
